import React from 'react';
import { Flex, Spin } from 'antd';

interface SpinnerProps {
  size?: 'small' | 'default' | 'large';
  height?: string | number;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'default', height = '100vh' }) => {
  return (
    <Flex justify="center" align="center" style={{ height }}>
      <Spin size={size} />
    </Flex>
  );
};

export default Spinner; 